module.exports = __webpack_public_path__ + "static/media/light_arr.3a8b5a8b.svg";